import type { AlertProps, IconNames } from '@petsmart-ui/sparky';

export type AlertBanner = {
    header: string;
    variant: AlertProps['variant'];
    text?: string;
    icon?: IconNames;
    dismissible?: boolean;
    skipScrollToAlert?: boolean;
};

export enum BannerType {
    INVALID_INFORMATION = 'invalidInformation',
    INVALID_SHIPPING_ADDRESS = 'invalidShippingAddress',
    INVALID_PAYMENT_METHOD_ADYEN = 'invalidPaymentMethodAdyen',
    INVALID_PAYMENT_METHOD_FORMIK = 'invalidPaymentMethodFormik',
    SUCCESS = 'success',
    VERIFICATION_EMAIL_RESENT = 'verificationEmailResent',
    VERIFY_YOUR_ACCOUNT = 'verifyYourAccount',
    OFFER_ACTIVATED = 'offerActivated',
    UNABLE_TO_ACTIVATE_OFFER = 'unableToActivateOffer',
}
